import '/assets/styles/partials/lottery-banner.scss';

import classNames from 'classnames';
import config from '@wearetla/tla-essentials-tools/config';

// Partials
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Img from '@wearetla/tla-essentials-tools/partials/img';

// Context
import { useTranslation } from '/utilities/i18n';

// Static Assets
import image_lottery_banner from '/assets/images/lottery/lottery-banner-plain.jpg';

// Web menüde çekiliş kampanyasını tanıtıp uygulama indirme linkine yönlendiren banner.
const LotteryBanner = ({ className }) => {
	const { t } = useTranslation();

	return (
		// /download, cihaza göre App Store ya da Play Store'a yönlendirir (sunucu tarafı route).
		<Link
			raw
			href={`${config.siteURL}${config.nativeApp?.downloadUrl ?? '/download'}`}
			target="_blank"
			rel="noopener noreferrer"
			title={t('IF Sokak uygulamasını indir')}
			className={classNames('lottery-banner', className)}
		>
			<div className="banner-imagewrap">
				<Img
					src={image_lottery_banner}
					lazy={false}
					className="banner-image"
					alt={t("IF Sokak'tan 4 iPhone 17 ve 16 AirPods hediye")}
				/>
			</div>
			<p className="banner-text">
				{t(
					"Her gün 21.00'den sonra yapacağın her 500₺'lik alkolsüz alışveriş 1 çekiliş hakkı kazandırır. Kampanya detayları için uygulamamızı indir!"
				)}
			</p>
		</Link>
	);
};

export default LotteryBanner;
